import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryLoading: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBatteryLoading"><Path d="M1 5H11.8125L6 12.75H12L7.3125 19H1V5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20 19H9.1875L15 11.25H9L13.6875 5H20V8H23V16H20V19ZM20 14.5H21.5V9.5H20V14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBatteryLoading;
